import { render, staticRenderFns } from "./PantallaInicio.html?vue&type=template&id=5128d316&external"
import script from "./PantallaInicio.vue?vue&type=script&lang=js"
export * from "./PantallaInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports